import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

// Asymmetric editorial grid of course cards
export default function CoursesGrid({ courses = [], heading = true, limit }) {
  const list = limit ? courses.slice(0, limit) : courses;

  return (
    <section className="bg-background py-24 md:py-32" data-testid="courses-section">
      <div className="rb-container">
        {heading && (
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <Reveal>
              <p className="overline text-accent-foreground/60 mb-4 flex items-center gap-3">
                <span className="h-px w-10 bg-[var(--rb-gold)] inline-block" /> Our Disciplines
              </p>
              <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-foreground max-w-2xl leading-[1.02]">
                Ten dance forms, one stage for every dreamer.
              </h2>
            </Reveal>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((c, i) => (
            <motion.article
              key={c.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              className={`group relative img-zoom cursor-pointer border border-transparent hover:border-[var(--rb-gold)] transition-colors duration-500 ${
                i % 5 === 0 ? "sm:row-span-2" : ""
              }`}
              data-testid={`course-card-${i}`}
            >
              <div className={`relative overflow-hidden ${i % 5 === 0 ? "h-[300px] sm:h-full min-h-[420px]" : "h-[300px]"}`}>
                <img src={c.image} alt={c.name} className="h-full w-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A0F2E] via-[#1A0F2E]/20 to-transparent" />
                <span className="absolute top-4 left-4 overline text-[10px] text-[#1A0F2E] bg-[var(--rb-gold)] px-3 py-1">
                  {c.category}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-[#F6F4EE] leading-tight">{c.name}</h3>
                    <p className="mt-2 text-sm text-[#F6F4EE]/70 max-w-xs line-clamp-2 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                      {c.description}
                    </p>
                  </div>
                  <span className="grid h-11 w-11 place-items-center bg-[#F6F4EE]/10 border border-[#F6F4EE]/20 text-[#F6F4EE] group-hover:bg-[var(--rb-gold)] group-hover:text-[#1A0F2E] transition-colors duration-400 shrink-0">
                    <ArrowUpRight className="h-5 w-5" />
                  </span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
